import Template from "components/Template/Template"
import { Button, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, MenuItem, Select, Switch, TextField, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import VISING_TYPES from "references/vising-types"
import { useDispatch, useSelector } from "react-redux"
import { AppState } from "store/store"
import * as serviceActions from 'store/ducks/services/actions';
import { MainLoader } from "components/Loader/Loader"
import SearchSelect, { ISearchData } from "components/SearchSelect/SearchSelect"
import { usersServices, visingServices } from "api/services"
import { ShowNotification } from "helpers/showNotice"
import { useNavigate, useParams } from "react-router"
import './UpdateVisingPage.sass'
import { Link } from "react-router-dom"



const UpdateVisingPage: React.FC = () => {
  const [branchId, setBranchId] = useState<number>()
  const [responsiblePersonId, setResponsiblePersonId] = useState<ISearchData>()
  const [type, setType] = useState<IVisingType>()
  const [step, setStep] = useState('')
  const [users, setUsers] = useState<ISearchData[]>()
  const [execute, setExecute] = useState(false)
  const [loading, setLoading] = useState(false)
  const { branches } = useSelector(
    (state: AppState) => state.services
  );
  const lang = useSelector((state: AppState) => state.i18n.key);
  const dispatch = useDispatch();
  const history = useNavigate()
	const { visingId } = useParams<{ visingId: string }>();


  useEffect(() => {
    getBranches()
  }, [])

  useEffect(() => {
    if(!visingId) return
    getData()
  }, [visingId])

  const getBranches = () => {
    if (!branches.length) dispatch(serviceActions.getBranches());
  };

  const getData = async () => {
    const res = await visingServices.getVisingById(Number(visingId)).then((res) => res.data)
    setBranchId(res.branchId)
    setExecute(res.execute)
    setStep(res.step.toString())
    setResponsiblePersonId({
      value: res.responsiblePersonId,
      label: `${res.responsiblePerson?.lastName} ${res.responsiblePerson?.firstName} ${res.responsiblePerson?.middleName}`
    })
    setType(res.type)
  }

  const getUsers = async (search?: string) => {
    const params = {
      search: search || '',
      skip: 0,
      take: 50,
    }
    const res = (
      await usersServices
        .getUsers(params)
        .then((res) => res.data)
    ).data.map((i) => ({
      value: i.id,
      label: `${i?.lastName} ${i?.firstName} ${i?.middleName}`,
    }));
    setUsers(res);
    return res;
  };


  const submit = async (e: React.FormEvent ) => {
    e.preventDefault()
    if(!responsiblePersonId || !type || !step.trim()) {
      ShowNotification('Поля не заполнены')
      return
    }

    const data = {
      branchId,
      step: Number(step),
      responsiblePersonId: responsiblePersonId.value,
      type,
      execute
    }
    try {
      setLoading(true)
      await visingServices.updateVising(Number(visingId), data)
      history('/vising')
    } catch {

    } finally {
      setLoading(false)
    }
  }


  return (
    <Template>
      <div className="update-vising-page">
        <Typography className="update-vising-page__title" variant='h3'>Обновить</Typography>
        <form onSubmit={submit}>
          <Grid container spacing={2}>
            <Grid item md={12}>
              <FormGroup>
                <FormControlLabel
                  control={<Switch onChange={(e) => setExecute(e.target.checked)} checked={execute} />}
                  label='Выполнить'
                />
              </FormGroup>
            </Grid>
            <Grid item md={12}>
              <FormControl fullWidth className='select-small'>
                <InputLabel variant='outlined' id='categoryId'>
                  Тип
                </InputLabel>
                <Select
                  labelId='categoryId'
                  label='Тип'
                  onChange={(e) => setType(e.target.value as IVisingType)}
                  value={type || ''}
                  size='small'
                >
                  {VISING_TYPES.map((i) => (
                    <MenuItem key={i.value} value={i.value}>
                      {i.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={12}>
              <FormControl fullWidth className='select-small'>
                <InputLabel variant='outlined' id='creationType'>
                  Филиал
                </InputLabel>
                <Select
                  labelId='branch'
                  label='Филиал'
                  onChange={(e) => setBranchId(Number(e.target.value))}
                  value={branchId || ''}
                  size='small'
                >
                  <MenuItem value={undefined}>
                    ---
                  </MenuItem>
                  {branches?.map((i) => (
                    <MenuItem key={i.id} value={i.id}>
                      {i[`name${lang}`]}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={12}>
              <TextField
                value={step}
                onChange={(e) => setStep(e.target.value)}
                type='number'
                size="small"
                label='Шаг'
              />
            </Grid>
            <Grid item md={12}>
              <SearchSelect
                options={users}
                placeholder={'Пользователь'}
                value={responsiblePersonId}
                onChange={setResponsiblePersonId}
                getOptions={getUsers}
                className='contracts-filter__field'
              />
            </Grid>
            <Grid item md={6} className='update-vising-page__button'>
              <Link to='/vising'>
                <Button
                  variant='contained'
                  color='inherit'
                  size='large'
                  className='update-vising-page__button'
                >
                    Назад
                </Button>
              </Link>
            </Grid>
            <Grid item md={6}>
              <Button
                variant='contained'
                color='success'
                className='update-vising-page__button'
                type='submit'
                disabled={loading}
                size='large'
              >
                {loading ? <MainLoader /> : 'Сохранить'}
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </Template>
  )
}

export default UpdateVisingPage